module.exports = __webpack_public_path__ + "cb3a302b9551a1da3bc0b3d65569b89a.svg";